import React from 'react';

// Força o tema padrão para tudo que estiver dentro (ex.: páginas de clube).
// display: contents não altera o layout. Obs.: conteúdo em portal do MUI
// (Modal, Drawer, Menu) é renderizado fora desta árvore e segue o tema ativo.
const ThemeScope = ({ theme = 'default', children }) => (
    <div data-theme={theme} style={{ display: 'contents' }}>
        {children}
    </div>
);

export default ThemeScope;
